/* src/app/order/components/company-has-certificate/company-has-certificate.style.scss */
.company-has-certificate-card {
  margin-top: 10px;
}
.company-has-certificate-card .form-row {
  align-items: baseline;
}
.company-has-certificate-card .form-row .radio-button-group {
  min-width: 140px;
  max-width: 160px;
  padding-right: 0;
  margin-right: 30px;
}
#certification-question {
  font-size: 15px;
  line-height: 22px;
  color: #585858 !important;
  vertical-align: sub !important;
}
nb-radio {
  display: inline-block !important;
}
.padding-top5 {
  padding-top: 5px;
}
.redirection-message-multisite {
  font-size: 15px;
  font-weight: bold;
  line-height: 24px;
  color: #007d40;
}
.button-redirect-link {
  text-decoration: none;
}
.button-redirect-link #redirect-button {
  font-size: 14px;
  width: 100%;
  max-width: 382px;
}
.button-redirect-link .arrow-icon {
  color: white;
}
.question-div {
  max-width: 513px;
}
@media screen and (max-width: 767px) {
  .company-has-certificate-card .form-row {
    flex-direction: column-reverse;
  }
  .company-has-certificate-card .form-row .radio-button-group {
    flex-basis: 100%;
  }
  .button-redirect-link #redirect-button {
    font-size: 12px;
    height: 30px;
    min-width: 295px;
  }
  .button-redirect-link .arrow-icon {
    height: 15px;
    width: 15px;
    position: relative;
    bottom: 2px;
  }
}
/*# sourceMappingURL=company-has-certificate.style.css.map */
